// extracted by mini-css-extract-plugin
module.exports = {"ShapedContainer":"ShapedContainer_ShapedContainer__1jozs","rounded":"ShapedContainer_rounded__3C2oI","bevelled":"ShapedContainer_bevelled__3Xgvh"};